import { Injectable } from "@angular/core";
import Utils from "src/app/shared/fgi-utils";
import { FileUtilsService } from "src/app/shared/file-utils.service";
import { DatePipe } from "@angular/common";
import { BnLoadingService } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnMaskCnpj, BnPipeCnpj } from "@bndes/bndes-ux4/bn-mask2/cpfcnpj";
import { ResultadoPaginado } from "src/app/model/resultado";
import { Subscricao } from "src/app/model/subscricao.model";
import { ParticipanteConglomerado } from "src/app/model/participante.conglomerado.model";
import { NumeroConglomeradoPipe } from "src/app/pipes/numero-conglomerado.pipe";
import { PercentPipe } from "@angular/common";
import { PatrimonioLiquido } from "src/app/model/patrimonio-liquido.model";
import { HabilitacaoAlternativa } from "src/app/model/habilitacao-alternativa.model";
import { FaixaCarteiraPessoaJuridica } from "src/app/model/faixa-carteira-pessoa-juridica.model";
import { MascaraCnaePermitido } from "src/app/model/mascara-cnae-permitido.model";
import { LimiteAportado } from "src/app/model/limite-aportado.model";
import { LimiteExposicao, LimiteLegadoDTO } from "src/app/model/limite-exposicao.model";
import { Renuncia, RenunciaDetalheDto } from "src/app/model/renuncia.model";

const LIMITE_EXPORTACAO_CSV = 5000;

@Injectable({
    providedIn: 'root'
})
export class ExportService {
    private totalResultados: number = 0;
    constructor(
        private fileUtils: FileUtilsService,
        private datePipe: DatePipe,
        private loading: BnLoadingService,
        private bnAlertsService: BnAlertsService,
        private bnPipeCnpj: BnPipeCnpj,
        private numeroConglomerado: NumeroConglomeradoPipe,
        private percent: PercentPipe,
    ) {}

    exportar(nome, csv) {
        if (this.totalResultados > LIMITE_EXPORTACAO_CSV) {
            this.bnAlertsService.alertaAviso('Atenção', 'A exportação está limitada às primeiras 5.000 operações. Utilize os filtros disponíveis para adequar a consulta.');
        }
        this.loading.liberaTela();
        this.fileUtils.exportarArquivo(nome, "\ufeff" + csv, FileUtilsService.TEXT_CSV);
    }

    exportarSubscricoes(resp: ResultadoPaginado<Subscricao>) {
        let subscricoes = resp?.resultados || null;
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        let csv = 'COTISTA; CNPJ; SIGLA; COTA; NUMERO APORTE; DATA SUBSCRICAO; VALOR APORTE; USUARIO RESPONSAVEL; DATA REGISTRO; DATA ATUALIZACAO; COD CONGLOMERADO\n';
        console.log("total de subscricoes para exportacao: " + subscricoes.length);
        subscricoes.forEach(subscricao => {
            let numeroConglomerado = ''
            if (subscricao.numeroConglomerado != null) {
              numeroConglomerado = this.toNumeroConglomeradoPipe(`${subscricao.numeroConglomerado}`);
            }
            csv += subscricao.cotista?.nome.toUpperCase() + ';'
            + this.bnPipeCnpj.transform(subscricao.cotista?.cnpj) + ';'
            + subscricao.cotista?.sigla + ';'
            + subscricao.categoriaCota + ';'
            + subscricao.numeroCota + ';'
            + subscricao.dataSubscricao + ';'
            + this.formatarMoeda(subscricao.valor) + ';'
            + subscricao.nomeUsuarioADResponsavel + ';'
            + this.formatarData(subscricao.dataRegistro) + ';'
            + this.formatarData(subscricao.dataAtualizacao, true) + ';'
            + numeroConglomerado + '\n';
        });
        this.exportar('Subscricoes.csv', csv);
    }

    exportarListaConglomerado(resp: ResultadoPaginado<ParticipanteConglomerado>) {
        let listaConglomerado = resp?.resultados || null;
        let csv = 'AGENTE FINANCEIRO; CNPJ; SIGLA; PERCENTUAL; CODIGO; DATA INICIO; DATA FIM; SITUACAO\n';
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        console.log("total de conglomerados para exportacao: " + this.totalResultados);
        listaConglomerado.forEach(conglomerado => {
            csv += conglomerado.agenteFinanceiro?.nome.toUpperCase() + ';'
            + this.bnPipeCnpj.transform(conglomerado.agenteFinanceiro?.cnpj) + ';'
            + conglomerado.agenteFinanceiro?.sigla + ';'
            + this.toPercentualPipe(conglomerado.percentual) + ';'
            + this.toNumeroConglomeradoPipe(conglomerado.codigo) + ';'
            + this.formatarData(conglomerado.dataInicial) + ';'
            + this.formatarData(conglomerado.dataFinal) + ';'
            + conglomerado.situacao + '\n';
        });
        this.exportar('Conglomerados.csv', csv);
    }

    exportarListaRenuncia(resp: RenunciaDetalheDto[]) {
        let csv = 'Agente Financeiro;CNPJ;Razão Social;Usuário Responsável;Data/Hora solicitação;Status da solicitação;Valor Distribuição 1;Valor Distribuição 2;Valor Distribuição 3;Valor Distribuição 4;Valor Distribuição 5;Valor Distribuição 6;Valor Distribuição 7;Valor Distribuição 8;Valor Distribuição 9;Valor Renúncia;Valor Descomprometido;Acréscimo 50% Limite Renunciante;Usuário Exclusão renúncia;Data/hora exclusão;Substituído por;Data/hora substituição\n';        this.totalResultados = resp.length;
        resp.forEach(renuncia => {

            csv += renuncia.nomeAgenteFinanceiro + ';'
            + this.bnPipeCnpj.transform(renuncia.cnpjAgenteFinanceiro) + ';'
            + renuncia.razaoSocialAgenteFinanceiro + ';'
            + (renuncia.ideUsuarioResponsavel || '') + ';'
            + this.formatarData(renuncia?.dataSolicitacao) + ';'
            + (renuncia.statusSolicitacao || '') + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao1) + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao2) + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao3) + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao4) + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao5) + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao6) + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao7) + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao8) + ';'
            + this.formatarMoeda(renuncia?.valorDistribuicao9) + ';'
            + this.formatarMoeda(renuncia?.valorRenunciado) + ';'
            + this.formatarMoeda(renuncia?.valorDescomprometidoNovasContratacoes) + ';'
            + this.formatarMoeda(renuncia?.acrescimoExclusivoAoLimiteRenunciante) + ';'
            + (renuncia.usuarioResponsavelExclusao || '') + ';'
            + this.formatarData(renuncia?.dataExclusao) + ';'
            + (renuncia.usuarioResponsavelSubstituicao || '') + ';'
            + this.formatarData(renuncia?.dataSubstituicao) + ';\n';
        });
        this.exportar('Renuncias.csv', csv);
    }

    exportarListaLimiteContratacao(resp: LimiteAportado[]) {
        let csv = 'Agente Financeiro;CNPJ;Razão Social;Valor subscrito;Limite garantia;Comprometido atual;Comprometido legado;Valor disponível\n';
        this.totalResultados = resp.length;
        console.log("total de limites para exportacao: " + this.totalResultados);
        resp.forEach(limite => {
            csv += limite.nomeAgente + ';'
            + this.bnPipeCnpj.transform(limite.cpfCnpj) + ';'
            + limite.razaoSocial + ';'
            + this.formatarMoeda(limite.valorSubscrito) + ';'
            + this.formatarMoeda(limite.valorLimiteGarantia) + ';'
            + this.formatarMoeda(limite.comprometido) + ';'
            + this.formatarMoeda(limite.comprometidoLegado) + ';'
            + this.formatarMoeda(limite.valorDisponivel) + ';\n';
        });
        this.exportar('Limite.csv', csv);
    }

    exportarListaPatrimoniosLiquidos(resp: ResultadoPaginado<PatrimonioLiquido>) {
        let lista = resp?.resultados || null;
        let csv = 'Data Base;Valor Patrimônio Líquido;Usuário Responsável;Data de Registro\n';
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        console.log("total de PLs para exportacao: " + this.totalResultados);
        lista.forEach(item => {
            csv += this.formatarData(item.dataBase) + ';'
            + this.formatarMoeda(item.valor) + ';'
            + item.nomeUsuarioADResponsavel.toUpperCase() + ';'
            + this.formatarData(item.dataRegistro, true) + ';' + '\n';
        });
        this.exportar('Patrimonios-liquidos.csv', csv);
    }

    exportarHabilitacoesAlternativas(resp: ResultadoPaginado<HabilitacaoAlternativa>) {
        let habilitacoes = resp?.resultados || null;
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        let csv = 'AGENTE FINANCEIRO; CNPJ; SIGLA; VALOR LIMITE; DATA INICIO; DATA MAXIMA VALIDADE; DATA SUSPENSAO; SITUACAO; JUSTIFICATIVA DA SUSPENSAO; DATA REGISTRO; DATA ATUALIZACAO; USUARIO RESPONSAVEL\n';
        console.log("total de habilitacoes para exportacao: " + habilitacoes.length);
        habilitacoes.forEach(habilitacao => {
            csv += habilitacao.agenteFinanceiro?.nome.toUpperCase() + ';'
            + this.bnPipeCnpj.transform(habilitacao.agenteFinanceiro?.cnpj) + ';'
            + habilitacao.agenteFinanceiro?.sigla + ';'
            + this.formatarMoeda(habilitacao.valorLimite) + ';'
            + this.formatarData(habilitacao.dataInicio) + ';'
            + this.formatarData(habilitacao.dataMaximaValidade) + ';'
            + this.formatarData(habilitacao.dataSuspensao) + ';'
            + (habilitacao?.situacao || '') + ';'
            + (habilitacao?.justificativaSuspensao || '') + ';'
            + this.formatarData(habilitacao.dataRegistro) + ';'
            + this.formatarData(habilitacao.dataAtualizacao, true) + ';'
            + habilitacao.usuarioADResponsavel + '\n';
        });
        this.exportar('Habilitações-Alternativas.csv', csv);
    }

    exportarListaFaixaPJ(resp: ResultadoPaginado<FaixaCarteiraPessoaJuridica>) {
        let lista = resp?.resultados || null;
        let csv = 'Agente Financeiro;CNPJ;Razão Social;Faixa;Data Início;Data Fim;Peso Conglomerado;Código do Conglomerado;Usuário Atualização Conglomerado;Data/Hora Registro Conglomerado;Usuário Atualização Faixa;Data/Hora Atualização Faixa\n';
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        console.log("total de faixas para exportacao: " + this.totalResultados);
        lista.forEach(item => {
            csv += item.nomeAgenteFinanceiro + ';'
            + this.bnPipeCnpj.transform(item.cnpjAgenteFinanceiro) + ';'
            + item.razaoSocial + ';'
            + item.valorFaixa.labelFaixa + ';'
            + this.formatarData(item.dataInicioValidade) + ';'
            + this.formatarData(item.dataFimValidade) + ';'
            + this.formatarVirgula(item.pesoConglomerado?.toString() || '') + ';'
            + (item.codigoConglomerado || '') + ';'
            + (item.usuarioConglomerado || '') + ';'
            + (this.formatarData(item.dataConglomerado, true) || '') + ';'
            + (item.nomeUsuarioFaixa || '') + ';'
            + this.formatarData(item.dataAtualizacaoFaixa, true) + '\n';
        });
        this.exportar('Faixas-PJ.csv', csv);
    }

    exportarCnaesPermitidos(resp: ResultadoPaginado<MascaraCnaePermitido>) {
        let lista = resp?.resultados || null;
        let csv = 'Máscara;Tipo da Operação;Objetivo do Financiamento;Início da validade de permissão;Fim da validade de permissão;Data/Hora Encerramento;Justificativa término da validade;Usuário responsável encerramento;Usuário Atualização;Data/Hora Atualização\n';
        this.totalResultados = resp.totalRegistrosSemPaginacao;
        console.log("total de mascaras para exportacao: " + this.totalResultados);
        lista.forEach(item => {
            csv += item.mascara + ';'
            + (item.tipoOperacao || '') + ';'
            + (item.objetivoFinanciamento || '') + ';'
            + this.formatarData(item.dataInicioValidade) + ';'
            + this.formatarData(item.dataFimValidade) + ';'
            + this.formatarData(item.dataEncerramento, true) + ';'
            + (item.justificativaEncerramento || '') + ';'
            + (item.usuarioResponsavelEncerramento || '') + ';'
            + (item.usuarioAtualizacao || '') + ';'
            + this.formatarData(item.dataHoraAtualizacao, true) + '\n';
        });
        this.exportar('CNAEs-permitidos.csv', csv);
    }

    exportarListaLimitesExposicao(resp: LimiteExposicao[], dadosImportacao: LimiteLegadoDTO, sigla: string) {
        const exibirLegado = this.deveExibirExposicaoLegado(sigla);
        let csv = 'Agente Financeiro;Sigla;CNPJ;Limite exposição;Exposição Atual;';

        if (exibirLegado) {
            csv += 'Exposição Legado;';
        }

        csv += 'Valor disponível';

        if (exibirLegado) {
            csv += ';Data/hora da importação;Login\n';
        } else {
            csv += '\n';
        }

        this.totalResultados = resp.length;
        console.log("total de limites para exportacao: " + this.totalResultados);
        resp.forEach(limite => {
            csv += limite.nomeAgente + ';'
            + limite.siglaAgente + ';'
            + this.bnPipeCnpj.transform(limite.cnpj) + ';'
            + this.formatarMoeda(limite.valorLimite) + ';'
            + this.formatarMoeda(limite.valorExposicaoAtual || 0) + ';';

            if (exibirLegado) {
                csv += this.formatarMoeda(limite.valorLimiteLegado || 0) + ';';
            }

            csv += this.formatarMoeda(limite.valorDisponivel || 0);

            if (exibirLegado) {
                csv += ';' + this.formatarData(dadosImportacao.dataImportacao, true) + ';'
                + dadosImportacao.usuarioImportacao + ';\n';
            } else {
                csv += "\n";
            }

        });
        this.exportar('Limite Exposição.csv', csv);
    }

    private deveExibirExposicaoLegado(sigla: string): boolean {
        return sigla !== 'FGBS';
    }

    formatarData(data: string | number | Date, comHora?: boolean) {
        const hora = comHora ? 'HH:mm:ss' : '';
        return data ? this.datePipe.transform(data, 'dd/MM/yyyy ' + hora) : '';
    }

    formatarMoeda(moeda) {
        if (!isNaN(moeda)) {
            return Number(moeda).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        }
        return '';
    }

    private toNumeroConglomeradoPipe(numero:string) {
        return this.numeroConglomerado.transform(numero, null);
    }

    private toPercentualPipe(numero:number) {
        return this.percent.transform(numero, '2.2-4');
    }

    formatarVirgula(valor: string) {
        return valor?.replace(/\./g, ',');
    }

}
